import { MutationFunctionOptions } from '@apollo/client';

import { readVideoFragment, writeVideoFragment } from 'src/app/helpers/graphql';

export function getAddVideoToWatchlistOptions(videoId: string, optimisticIsInWatchlist: boolean): MutationFunctionOptions {
  return {
    optimisticResponse: {
      addVideoToWatchlist: {
        __typename: 'GQLVideo',
        isInWatchlist: optimisticIsInWatchlist
      }
    },
    update: (store, { data }) => {
      // No need to write if there is no data / cache
      // Apollo will not use fragment cache with incomplete fragment data
      const videoFragment = readVideoFragment(store, videoId);
      if (data && videoFragment) {
        writeVideoFragment(store, {
          ...videoFragment,
          isInWatchlist: data.addVideoToWatchlist.isInWatchlist
        });
      }
    },
    variables: {
      videoId
    }
  };
}

export function getRemoveVideoFromWatchlistOptions(videoId: string, optimisticIsInWatchlist: boolean): MutationFunctionOptions {
  return {
    optimisticResponse: {
      removeVideoFromWatchlist: {
        __typename: 'GQLVideo',
        isInWatchlist: optimisticIsInWatchlist
      }
    },
    update: (store, { data }) => {
      const videoFragment = readVideoFragment(store, videoId);
      if (data && videoFragment) {
        writeVideoFragment(store, {
          ...videoFragment,
          isInWatchlist: data.removeVideoFromWatchlist.isInWatchlist
        });
      }
    },
    variables: {
      videoId
    }
  };
}
